import { ReactNode } from 'react';
import { CompoundFilter, CompoundFilterOptionsProps } from '@trukt/ui/CompoundFilter';
import { OrderListCompoundFilterLiterals } from '../../hooks/use-order-list-compound-filter';
import { SearchContactInput } from './components/SearchContactInput';
import { DateFilter } from './components/date-filter';
import { SearchBranchInput } from './components/SearchBranchInput';
import { LocationFilter } from './components/location-filter';

export const SubTopicOptions = () => {
  const renderOptionPrefix: CompoundFilterOptionsProps['renderOptionPrefix'] = (props) => {
    const itemId = props.itemId as OrderListCompoundFilterLiterals;

    const map: Record<OrderListCompoundFilterLiterals, ReactNode> = {
      status: <></>,
      contacts: <SearchContactInput {...props} />,
      dates: <DateFilter {...props} />,
      pickup: <LocationFilter {...props} />,
      delivery: <LocationFilter {...props} />,
      branches: <SearchBranchInput {...props} />,
    };

    return map[itemId] ?? null;
  };

  return (
    <div className="flex min-h-10 items-center">
      <CompoundFilter.Options renderOptionPrefix={renderOptionPrefix} />;
    </div>
  );
};
